import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
`;

export const SlideContainer = styled.div<{$currentpage: 'list' | 'detail'}>`
    display: flex;
    width: 200%;
    height: 100%;
    transform: translateX(${(props) => (props.$currentpage === 'list' ? '0' : '-50%')});
    transition: transform 0.3s ease-in-out;
`;

export const PageWrapper = styled.div`
    width: 50%;
    height: 100%;
    overflow-y: auto;
`;

export const TableWrapper = styled.div`
    max-height: 100%;
    height: 100%;
    overflow-y: auto;
    border-radius: 10px;
    background-color: #2d2d2d;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #fff;
    font-size: 2em;

    thead {
        background-color: #222;
        position: sticky;
        top: 0;
        z-index: 1;
    }

    th,
    td {
        padding: 12px;
        text-align: left;
        border-bottom: 1px solid #333;
    }
`;

export const Row = styled.tr<{$focused?: boolean}>`
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #1d1d1d;
    }

    ${(props) =>
        props.$focused &&
        `
        background-color: #00bfff !important;
        color: #000 !important;
        font-weight: bold;
        
        td {
            background-color: #00bfff;
            color: #000;
        }
    `}
`;

export const MsgContainer = styled.div`
    background-color: #111;
    color: #fff;
    padding: 20px;
    border-radius: 12px;
`;

export const BackButton = styled.button<{$focused?: boolean}>`
    background: none;
    border: 2px solid #3ab8ff;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 20px;

    &:hover {
        background-color: #00bfff;
        color: #000;
    }

    ${(props) =>
        props.$focused &&
        `
        background-color: #00bfff !important;
        color: #000 !important;
        box-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
        transform: scale(1.05);
    `}
`;

export const HeaderRow = styled.div`
    display: flex;
    gap: 1rem;
    font-size: 1.5rem;
    align-items: center;
    flex-wrap: wrap;
`;

export const Label = styled.span`
    margin-right: 4px;
`;

export const Divider = styled.div<{dashed?: boolean}>`
    margin: 1rem 0;
    border-style: none;
    border-top: ${(props) => (props.dashed ? '1px dashed #444' : '1px solid #444')};
`;

export const Title = styled.h2`
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
`;

export const Body = styled.div<{$focused?: boolean}>`
    display: flex;
    gap: 20px;
    align-items: flex-start;
    flex-wrap: wrap;
    position: relative;
    border-radius: 8px;
    padding: 10px;
    transition: all 0.2s ease;

    ${(props) =>
        props.$focused &&
        `
        border: 2px solid #00bfff;
        box-shadow: 0 0 10px rgba(0, 191, 255, 0.3);
        background-color: rgba(0, 191, 255, 0.05);
    `}
`;

export const ScrollableContent = styled.div`
    max-height: 400px;
    overflow-y: auto;
    width: 100%;
    padding-right: 10px;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #2d2d2d;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #00bfff;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #0099cc;
    }
`;

export const MediaImg = styled.img`
    max-width: 400px;
    width: 100%;
    height: auto;
    border-radius: 6px;
`;

export const MediaVideo = styled.video`
    max-width: 400px;
    width: 100%;
    height: auto;
    border-radius: 6px;
`;

export const Content = styled.div`
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.6;
    color: #fff;
`;
